import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';

import { RootErrorBoundary } from './app/RootErrorBoundary';
import { isMarketingHost } from './client/marketingHost';
import { logVersionBanner } from './version';
import './styles/global.css';

logVersionBanner();

// Side-effect: registers the 'mxt' icon library with Web Awesome so
// `<wa-icon library="mxt" name="…">` resolves to our SVGs, and overrides
// the 'system' library so internal wa-* icons (e.g. wa-input's password
// toggle) pick up the MXT show/hide icons. Must run before any wa-icon
// instance mounts — keeping it here, ahead of createRoot, guarantees that.
import '@mxt/mxt-design-system';

const container = document.getElementById('root');
if (!container) {
    throw new Error('Root container #root not found in index.html');
}

// Pick the tree by host: the apex / www marketing surface gets a minimal,
// provider-free root; every other host gets the full app. Both are lazy so
// neither bundle pulls in the other's tree — notably the Descope SDK + the
// app's provider stack stay out of the public marketing bundle. (Each tree's
// composition lives in its own root component; this file just mounts one.)
const Root = lazy(() =>
    typeof window !== 'undefined' && isMarketingHost(window.location.hostname) ? import('./marketing/MarketingRoot') : import('./app/AppRoot')
);

createRoot(container).render(
    <StrictMode>
        <RootErrorBoundary>
            <Suspense fallback={null}>
                <Root />
            </Suspense>
        </RootErrorBoundary>
    </StrictMode>
);
